/**
 * 他ページから `?tab=<key>` で来たときに最初に開くタブ。
 *
 * タブの値は日本語のラベルなので URL には英字のキーを使う。知らないキーは既定のタブ。
 */
const TAB_PARAMS: Record<string, string> = {
  'ad-accounts': '広告連携',
};

export const DEFAULT_KNOWLEDGE_TAB = '戦略マップ';

export const knowledgeTabFromParam = (tabParam: string | null): string =>
  (tabParam && TAB_PARAMS[tabParam]) || DEFAULT_KNOWLEDGE_TAB;
